import { colorBrandPrimary, fontFamily } from 'src/global.style';
import styled from 'styled-components';
import { media } from 'src/layouts/utils';


export const Container = styled.div`
  max-width: 100%;
  min-width: 13rem;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const CardHeader = styled.div`
  width: 100%;
  height: auto;
  /* background: #ffffff; */
  border-radius: 1rem;
  opacity: 1;
  margin-bottom: -15px;
  z-index: 3;
  position: relative;

  ${media.phone`
    width: 16.7rem;
  `}

  .subtitle {
    padding: 0.625rem 1.25rem 1.25rem;
    text-align: center;
    font-family: ${fontFamily.brand};
    font-size: 1.25rem;
    opacity: 1;
    color: ${({ blur }) => (blur ? "transparent" : "#180700")};
    text-shadow: ${({ blur }) => (blur ? `0 0 4px #180700` : "none")};
    user-select: ${({ blur }) => (blur ? "none" : "auto")};
  }

  .subtitle-2 {
    padding: 0.25rem 0 0.875rem;
    text-align: center;
    font-family: ${fontFamily.brand};
    font-size: 1.25rem;
    opacity: 1;
    color: ${({ blur }) => (blur ? "transparent" : "#180700")};
    text-shadow: ${({ blur }) => (blur ? `0 0 4px #180700` : "none")};
    user-select: ${({ blur }) => (blur ? "none" : "auto")};
  }

  p {
    font-size: 1rem;
    padding: 0 1.25rem 2rem;
    text-align: center;
    color: ${({ blur }) => (blur ? "transparent" : "#180700")};
    text-shadow: ${({ blur }) => (blur ? `0 0 4px #180700` : "none")};
    user-select: ${({ blur }) => (blur ? "none" : "auto")};
  }
`;

export const CardBody = styled.div`
  z-index: 1;
  width: 100%;
  padding-bottom: 32px;
  overflow: hidden;
  opacity: 1;
  display: flex;
  justify-content: center;
  flex-direction: row;
  font-weight: 500;

  ${media.phone`
    padding-bottom: 0;
  `}
`;

export const Title = styled.div`
  font-size: 2rem;
  font-family: ${fontFamily.brand};
  text-align: center;
  width: 100%;
  color: ${({ blur }) => (blur ? "transparent" : "#FF2832")};
  text-shadow: ${({ blur }) => (blur ? `0 0 4px #180700` : "none")};
  user-select: ${({ blur }) => (blur ? "none" : "auto")};
  ${media.phone`
    font-size: 24px;
    line-height: 2rem;
    font-weight: 500;
    padding: 0 19px 24px 19px;
  `}
`;
export const Banner = styled.div`
  width: 100%;
  border-radius: 0.5rem;
  max-height: 7.625rem;
  overflow: hidden;

  display: grid;
  place-items: initial;
`;

export const Subtitle = styled.div`
  padding-left: 16px;
  .subtitle-2 {
    width: 70%;
    font-family: ${fontFamily.brand};
    font-size: 1.75rem;
    line-height: 1.8rem;
    opacity: 1;
    color: ${({ blur }) => (blur ? "transparent" : `${colorBrandPrimary.blue}`)};
    text-shadow: ${({ blur }) => (blur ? `0 0 4px #180700` : "none")};
    user-select: ${({ blur }) => (blur ? "none" : "auto")};

    ${media.phone`
      width: 100%;
      padding: 0.25rem 0 1.875rem;
      text-align: center;
      font-size: 18px;
      opacity: 1;
      font-weight: 500;
    `}
  }

  p {
    font-size: 16px;
    width: 60%;
    padding-top: 16px;
    color: ${({ blur }) => (blur ? "transparent" : `${colorBrandPrimary.blue}`)};
    text-shadow: ${({ blur }) => (blur ? `0 0 4px #180700` : "none")};
    user-select: ${({ blur }) => (blur ? "none" : "auto")};

    ${media.phone`
      width: 100%;
      padding: 0 0.5rem 1rem;
      text-align: center;
    `}
  }
  p:nth-child(2) {
    display: none;
  }
  
  ${media.phone`
    padding-left: 0;
  `}
`;

export const Benefits = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  hr {
    width: 100%;
    border: 0;
    border-top: 2px solid rgb(88, 83, 128);
    opacity: 0.16;
    font-weight: 500;
  }
  ${media.phone`
      > div:nth-child(1) {
        order: 1;
        background: #fff;
      }

      > div:nth-child(2) {
        order: 2;
        background: #fff;
      }

      > div:nth-child(3) {
        order: 3;
        background: #fff;
      }

      > div:nth-child(4) {
        order: 4;
        background: #fff;
      }
      width: 100%;
    `};
`;
export const Benefit = styled.div`
  font-family: ${(props) => props.bold && `${fontFamily.neutral}`};
  font-size: ${(props) => (props.bold ? '1.25rem' : '1rem')};
  color: ${({ blur }) => (blur ? 'transparent' : `${colorBrandPrimary.blue}`)};
  width: 100%;
  text-align: left;
  text-shadow: ${({ blur }) =>
    blur ? `0 0 8px ${colorBrandPrimary.marine}` : 'none'};

  ${media.phone`
    font-size: 1rem;
  `}
`;
export const Item = styled.div`
	display: flex;
	flex-direction: row;
	align-items: baseline;
	gap: 0.75rem;
	width: 100%;

  ${media.phone`
		align-items: center;
		background: #EDEDED;
  `}
`;
export const Badge = styled.div`
  position: absolute;
  z-index: 2;
  top: -10px;
  left: 69.5px;
  width: 125px;
  height: 29px;
  background: #8b2ce1;
  border-radius: 20px;
  p {
    font-family: "Open Sans";
    font-size: 0.75rem;
    color: #ffffff;
    text-align: center;
    text-shadow: none;
    padding: 0.375rem 0.75rem;
  }
`;

export const CardFooter = styled.div`
  width: 16.5rem;
  height: auto;
  p {
    font-family: "Open Sans";
    font-weight: normal;
    font-size: 0.9rem;
    color: #353536;
    padding: 1.5rem 0 1.7rem;
  }
`;

export const IconButton = styled.button`
  background-color: transparent;
  border: none;
  box-shadow: none;
  pointer-events: ${({ disabled }) => disabled && "none"};
`;

export const BenefitContainer = styled.div`
  display: flex;
  width: 100%;
  flexdirection: row;
  alignitems: center;
`;
